/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Aufbau, Knopfform UND angebotene Befehle der Detailmaske fuer EIN Geraet.
 * Die acht `show*`-Schalter sind das Gegenstueck zu den Inhalten der Uebersichten (`DatabaseNavigationSetting`): Dort wie hier steht je Geraet, WAS die Bedienung anbietet. Bis zum 29.08.2026 kannte die Detailmaske dafuer nur `hideDetailToolbar` — alles oder nichts.
 * FEHLT EIN SCHALTER, GILT ER ALS EIN. Bestehende Datenbanken zeigen damit unveraendert alle Befehle; nur wer abwaehlt, veraendert etwas. `hideDetailToolbar` bleibt daneben bestehen und nimmt weiterhin alles auf einmal weg.
 * @export
 * @interface DatabaseDetailmaskeSetting
 */
export interface DatabaseDetailmaskeSetting {
    /**
     * Der Aufbau, aus dem UX-Prototyp v6:
     * RASTER              Fliessendes Drei-Spalten-Raster (Vorgabe,
     *                     entspricht dem heutigen Aufbau).
     * KARTEN              Abschnitte als abgesetzte Karten. REITER              Abschnitte als Reiter nebeneinander. SPLIT_OBEN_UNTEN    Oben die Hauptdatenbank mit Reitern, unten die
     *                     Sub-Datenbanken mit eigenen Reitern.
     * SPLIT_LINKS_RECHTS  Links die Hauptdatenbank, rechts die
     *                     Sub-Datenbanken, beide mit Reitern; unter
     *                     992 Pixeln untereinander.
     * BIBLIOTHEK          Der Aufbau der Vorlage "Bibliothek": grosses
     *                     Bild, Metazeile aus Rubrik, Signatur und
     *                     Datum, darunter Titel und Volltext.
     * 
     * ADVENT              Der Aufbau der Vorlage "Adventskalender":
     *                     Tuerchen-Marke, Headline und Unterzeile,
     *                     darunter je nach Rolle "Art" GENAU EIN
     *                     Medium -- Volltext, Sprachnachricht, Video
     *                     oder Bild mit Unterschrift. Was nicht zur
     *                     Art gehoert, bleibt im Datensatz, aber
     *                     nicht auf dieser Seite.
     * 
     * BIBLIOTHEK WIRD NUR ANGEBOTEN, wenn ein Bibliothek-Stil hinterlegt ist: Er zeichnet die acht Zuordnungsrollen der Vorlage, und ohne sie staende eine leere Maske da. Der Standard bleibt daneben waehlbar (Vorgabe des Betreibers 01.10.2026: "Bei den Detailmasken koennen wir auch den Standard anbieten, plus eine weitere wie aus der Vorgabe").
     * NUR ZUM ANSEHEN. Beim Bearbeiten und Anlegen erscheint immer das gewohnte Formular: Ein Plattenteller hat keine Eingabefelder, und eine Maske, in der man nichts aendern kann, ist keine Maske.
     * SPRECHENDE NAMEN STATT VAR1..VAR5: Eine gespeicherte Nummer sagt spaeter niemandem mehr etwas — und wird ein Aufbau ersetzt, verschoebe die Nummer die Bedeutung aller bestehenden Werte.
     * Fehlt der Wert, gilt RASTER: Bestehende Datenbanken veraendern sich dadurch nicht von selbst.
     * @type {string}
     * @memberof DatabaseDetailmaskeSetting
     */
    variant?: DatabaseDetailmaskeSettingVariantEnum;
    /**
     * Form der Aktionsknoepfe im Kopf der Detailmaske.
     * ICONS      Nur Symbole (Vorgabe) — Beschriftung im Tooltip. ICON_TEXT  Symbol mit Beschriftung — verstaendlicher, braucht Platz. BURGER     Alle Befehle in einem Menue hinter einem Knopf.
     * Fehlt der Wert, gilt ICONS.
     * @type {string}
     * @memberof DatabaseDetailmaskeSetting
     */
    buttonStyle?: DatabaseDetailmaskeSettingButtonStyleEnum;
    /**
     * Anteil des ERSTEN Bereichs an der Flaeche, in Prozent — bei SPLIT_LINKS_RECHTS die linke Spalte, bei SPLIT_OBEN_UNTEN der obere Bereich. Der zweite Bereich bekommt den Rest.
     * NUR FUER DIE BEIDEN SPLIT-AUFBAUTEN. Bei RASTER, KARTEN und REITER gibt es nichts zu teilen; der Wert wird dort ignoriert, statt ihn zu loeschen — wer zwischen den Aufbauten hin- und herprobiert, findet seine Einstellung sonst jedes Mal zurueckgesetzt.
     * DREI FESTE WERTE, KEINE FREIE ZAHL (Vorgabe des Betreibers 28.08.2026: "25/75 und 75/25", dazu die Haelfte als Vorgabe). Ein Regler boete dreizehn Werte an, von denen zwoelf niemand braucht — und er laedt dazu ein, 45/55 einzustellen, was auf dem Bildschirm nicht von 50/50 zu unterscheiden ist.
     * Fehlt der Wert, gilt 50 — die Haelfte, wie bisher fest verdrahtet.
     * @type {number}
     * @memberof DatabaseDetailmaskeSetting
     */
    splitRatio?: DatabaseDetailmaskeSettingSplitRatioEnum;
    /**
     * Zeigt "E-Card ansehen". Wirkt nur, wo es ueberhaupt eine E-Card gibt — sonst steht der Befehl auch eingeschaltet nicht da.
     * @type {boolean}
     * @memberof DatabaseDetailmaskeSetting
     */
    showEcard?: boolean;
    /**
     * Zeigt "Neuer Eintrag" im Kopf der Detailmaske.
     * @type {boolean}
     * @memberof DatabaseDetailmaskeSetting
     */
    showAdd?: boolean;
    /**
     * Zeigt "Bearbeiten". Das Recht bleibt davon unberuehrt: Wer nicht bearbeiten darf, sieht den Knopf auch eingeschaltet nicht.
     * @type {boolean}
     * @memberof DatabaseDetailmaskeSetting
     */
    showEdit?: boolean;
    /**
     * Zeigt "Drucken".
     * @type {boolean}
     * @memberof DatabaseDetailmaskeSetting
     */
    showPrint?: boolean;
    /**
     * Zeigt "Per Mail versenden" (Weiterleiten).
     * @type {boolean}
     * @memberof DatabaseDetailmaskeSetting
     */
    showMail?: boolean;
    /**
     * Zeigt "Link kopieren".
     * @type {boolean}
     * @memberof DatabaseDetailmaskeSetting
     */
    showLink?: boolean;
    /**
     * Zeigt "Loeschen". Wie beim Bearbeiten entscheidet das Recht zusaetzlich.
     * @type {boolean}
     * @memberof DatabaseDetailmaskeSetting
     */
    showDelete?: boolean;
    /**
     * Zeigt die Pfeile "Vorheriger/Naechster Eintrag". Sie stehen ohnehin nur da, wo es einen Nachbarn gibt.
     * @type {boolean}
     * @memberof DatabaseDetailmaskeSetting
     */
    showBlaettern?: boolean;
}


/**
 * @export
 */
export const DatabaseDetailmaskeSettingVariantEnum = {
    Raster: 'RASTER',
    Karten: 'KARTEN',
    Reiter: 'REITER',
    SplitObenUnten: 'SPLIT_OBEN_UNTEN',
    SplitLinksRechts: 'SPLIT_LINKS_RECHTS',
    Bibliothek: 'BIBLIOTHEK',
    Advent: 'ADVENT'
} as const;
export type DatabaseDetailmaskeSettingVariantEnum = typeof DatabaseDetailmaskeSettingVariantEnum[keyof typeof DatabaseDetailmaskeSettingVariantEnum];

/**
 * @export
 */
export const DatabaseDetailmaskeSettingButtonStyleEnum = {
    Icons: 'ICONS',
    IconText: 'ICON_TEXT',
    Burger: 'BURGER'
} as const;
export type DatabaseDetailmaskeSettingButtonStyleEnum = typeof DatabaseDetailmaskeSettingButtonStyleEnum[keyof typeof DatabaseDetailmaskeSettingButtonStyleEnum];

/**
 * @export
 */
export const DatabaseDetailmaskeSettingSplitRatioEnum = {
    NUMBER_25: 25,
    NUMBER_50: 50,
    NUMBER_75: 75
} as const;
export type DatabaseDetailmaskeSettingSplitRatioEnum = typeof DatabaseDetailmaskeSettingSplitRatioEnum[keyof typeof DatabaseDetailmaskeSettingSplitRatioEnum];


/**
 * Check if a given object implements the DatabaseDetailmaskeSetting interface.
 */
export function instanceOfDatabaseDetailmaskeSetting(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseDetailmaskeSettingFromJSON(json: any): DatabaseDetailmaskeSetting {
    return DatabaseDetailmaskeSettingFromJSONTyped(json, false);
}

export function DatabaseDetailmaskeSettingFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseDetailmaskeSetting {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'variant': !exists(json, 'variant') ? undefined : json['variant'],
        'buttonStyle': !exists(json, 'buttonStyle') ? undefined : json['buttonStyle'],
        'splitRatio': !exists(json, 'splitRatio') ? undefined : json['splitRatio'],
        'showEcard': !exists(json, 'showEcard') ? undefined : json['showEcard'],
        'showAdd': !exists(json, 'showAdd') ? undefined : json['showAdd'],
        'showEdit': !exists(json, 'showEdit') ? undefined : json['showEdit'],
        'showPrint': !exists(json, 'showPrint') ? undefined : json['showPrint'],
        'showMail': !exists(json, 'showMail') ? undefined : json['showMail'],
        'showLink': !exists(json, 'showLink') ? undefined : json['showLink'],
        'showDelete': !exists(json, 'showDelete') ? undefined : json['showDelete'],
        'showBlaettern': !exists(json, 'showBlaettern') ? undefined : json['showBlaettern'],
    };
}

export function DatabaseDetailmaskeSettingToJSON(value?: DatabaseDetailmaskeSetting | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'variant': value.variant,
        'buttonStyle': value.buttonStyle,
        'splitRatio': value.splitRatio,
        'showEcard': value.showEcard,
        'showAdd': value.showAdd,
        'showEdit': value.showEdit,
        'showPrint': value.showPrint,
        'showMail': value.showMail,
        'showLink': value.showLink,
        'showDelete': value.showDelete,
        'showBlaettern': value.showBlaettern,
    };
}

